import { SimpleChipsInput } from '@mi-front/ui';
import { Box } from '@mui/material';
import { useFormikContext } from 'formik';
import { useIntl } from 'react-intl';
import { GipReportValues } from '../../types';

/**
 * Free-form chips input for GIP custom ID filters. Values are stored as `{ customId }`
 * objects to match the report DTO mapping in `gip-report-values-to-data-dto`.
 */
export function CustomIdsField() {
  const { $t } = useIntl();
  const { values, setFieldValue, isSubmitting } = useFormikContext<GipReportValues>();

  return (
    <Box mb={1}>
      <SimpleChipsInput
        value={values.customIds.map((item) => item.customId)}
        label={$t({
          id: 'audit.gipReport.form.customIds',
          defaultMessage: 'ID material',
        })}
        onChange={(_event, chipStrings) =>
          setFieldValue(
            'customIds',
            chipStrings.map((customId) => ({ customId })),
          )
        }
        readOnly={isSubmitting}
      />
    </Box>
  );
}
